import Image from "next/image";

export default function InfoCard({ number, title, description, imageUrl, imagePosition,imageCar }: {
    number: number;
    title: string;
    description: string;
    imageUrl: string;
    imagePosition: "left" | "right";
    imageCar: string;
}) {
    return (
        <div className="flex items-center gap-6">

            {imagePosition === "left" && (
                <div className="hidden shrink-0 xl:block">
                    <Image
                        src={imageCar}
                        alt={title}
                        width={380}
                        height={320}
                        className="rounded-lg object-cover"
                    />
                </div>
            )}

            <div className={`${imagePosition === "left" ? "max-md:flex-col-reverse" : ""} flex flex-col items-center gap-4 rounded-lg border border-gray-200 bg-gray-50 p-5 shadow-sm md:flex-row md:p-6`}>
                {imagePosition === "left" && (
                    <div className="shrink-0">
                        <Image
                            src={imageUrl}
                            alt={title}
                            width={380}
                            height={320}
                            className="rounded-lg object-cover"
                        />
                    </div>
                )}
                <div className={`flex items-start gap-x-4 md:gap-x-6 ${imagePosition === "left" ? "md:flex-row-reverse" : ""}`}>
                    <div className="flex items-center gap-4">
                        <div className="flex h-16 w-16 items-center justify-center rounded-full border border-gray-200 bg-white text-3xl font-normal md:h-20 md:w-20 md:text-4xl">
                            {number}
                        </div>
                    </div>
                    <div className="flex flex-col">
                        <h3 className="text-2xl font-semibold text-gray-900 md:text-3xl">{title}</h3>
                        <p className="mt-2 text-base leading-7 text-gray-600 md:text-lg">{description}</p>
                    </div>
                </div>
                {imagePosition === "right" && (
                    <div className="shrink-0">
                        <Image
                            src={imageUrl}
                            alt={title}
                            width={380}
                            height={320}
                            className="rounded-lg object-cover"
                        />
                    </div>
                )}
            </div>

            {imagePosition === "right" && (
                <div className="hidden shrink-0 xl:block">
                    <Image
                        src={imageCar}
                        alt={title}
                        width={380}
                        height={320}
                        className="rounded-lg object-cover"
                    />
                </div>
            )}
        </div>

    );
}
